/* Utils */
import { generateSelectEntityById, generateSelectEntitiesByIdsList } from '../utils/generators/selectorGenerators';

export const selectAllRequests = (state) => state.requests;

export const selectRequestById = generateSelectEntityById(selectAllRequests);

export const selectRequestsListByIdsList = generateSelectEntitiesByIdsList(selectAllRequests);
